<template>
  <div class="compliance-playground">
    <title-bar :title-stack="titleStack" />
    <div class="blur-background" :style="backgroundImageStyle"></div>
    <hero-bar>
      Compliance Cost Playground List
      <div slot="right">
        <!-- <button class="button is-primary">
          &nbsp; &nbsp;New Custom Playground&nbsp; &nbsp;
        </button> -->
      </div></hero-bar
    >
    <section
      class="section is-main-section compliance-section"
      v-if="hasComplianceCostPermission"
    >
      <b-collapse :open="true" aria-id="contentIdForA11y1">
        <template #trigger="props">
          <div
            class="card-header"
            role="button"
            aria-controls="contentIdForA11y3"
            :aria-expanded="props.open"
          >
            <h3 class="card-header-title">
              Playground Presets Scenarios
            </h3>
            <a class="card-header-icon">
              Hide/Show Presets
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"> </b-icon>
            </a>
          </div>
        </template>

        <div class="columns is-multiline">
          <div
            class="column is-12-mobile is-6-tablel is-6-widescreen is-4-fullhd"
            v-for="(item, key) in presetListData"
            :key="key"
          >
            <div class="box presets-box">
              <div class="column is-7">
                <span class="presets-box-text">{{
                  item.preset_scenario_name
                }}</span>
              </div>
              <div class="column is-3">
                <b-select
                  placeholder="Select"
                  v-if="item.preset_scenario_top_metric"
                  class="presets-select"
                  v-model="item.selected"
                >
                  <!-- <option v-for="({val, index}, key) in item.preset_scenario_top_metric" :value=index :key="key" selected>{{val}}{{index}}{{key}}</option> -->
                  <option
                    v-for="(v, k) in item.preset_scenario_top_metric"
                    :value="Object.keys(v)[0]"
                    :key="k"
                    >{{ Object.values(v)[0] }}</option
                  >
                </b-select>
              </div>
              <div class="column is-2">
                <b-button
                  class="button is-primary"
                  :disabled="item.selected ? false : true"
                  @click="openCreatePlaygroundModal(item)"
                  >Try it</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
      <playground-list-view
        :customer_id="switchCustomerId"
        :newDataAdded="newDataAdded"
        :presetDropDownList="presetDropDownList"
      />
      <create-playground-modal
        :item="item"
        @confirm="createPlayground"
        @cancel="closeCreatePlaygroundModal"
        :is-active="isCreatePlaygroundModal"
      ></create-playground-modal>
    </section>
    <section
      class="section is-main-section compliance-section"
      v-if="!hasComplianceCostPermission"
    >
      <div class="permission-card">
        <div class="card">
          <div class="card-content">
            <div class="columns is-variable">
              <div class="column permission-content">
                <div class="permission-heading mb-2">
                  <h3 class="title is-4">
                    Unlock full visibility into your compliance costs
                  </h3>
                </div>
              </div>
              <div class="column is-narrow permission-image">
                <img
                  src="~@/assets/compliance-lock.png"
                  alt="Compliance dashboard lock"
                  class="permission-icon"
                />
              </div>
            </div>
            <div class="columns is-variable">
              <div class="column is-narrow permission-text">
                <p class="subtitle is-6 mb-2">
                  Across all your products, materials, sales countries, and
                  compliance schemes. Gain powerful insights to control,
                  optimize, and plan your expenses more effectively.
                </p>
                <p class="contact-text mb-4">
                  Contact your Customer Account Manager today to learn more.
                  We’re here to help you get started.
                </p>
              </div>
            </div>
            <div class="columns is-variable">
              <div class="column has-text-centered">
                <button
                  class="button is-primary center-button"
                  @click="redirectToDashboard"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import HeroBar from "@/components/HeroBar";
import TitleBar from "@/components/TitleBar";
import utitlityMixin from "@/mixins/UtilityMixin";
import PlaygroundService from "../../services/PlaygroundService";
import CreatePlaygroundModal from "@/components/Compliance/Playground/CreatePlaygroundModal";
import PlaygroundListView from "@/components/Compliance/Playground/PlaygroundListView.vue";
export default {
  name: "PlaygroundList",
  mixins: [utitlityMixin],
  components: {
    HeroBar,
    TitleBar,
    CreatePlaygroundModal,
    PlaygroundListView
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "isUserExternal",
      "mappedCustomer",
      "switchCustomerView"
    ]),
    backgroundImageStyle() {
      return {
        // Use a gradient that matches the compliance dashboard theme with a more vibrant pattern
        backgroundImage:
          "radial-gradient(circle at 90% 10%, #b3e5fc 0%, rgba(179, 229, 252, 0.3) 30%, rgba(225, 245, 254, 0.5) 60%), linear-gradient(135deg, #f5f5f5 0%, #e0f7fa 40%, #b3e5fc 100%)",
        backgroundAttachment: "fixed"
      };
    },
    titleStack() {
      return [{ url: "#", name: "Compliance Cost Playground" }];
    }
  },
  data() {
    return {
      PlaygroundService: new PlaygroundService(),
      switchCustomerId: null,
      isLoading: false,
      presetListData: [],
      presetDropDownList: [],
      isCreatePlaygroundModal: false,
      item: {},
      presetsConut: null,
      newDataAdded: [],
      hasComplianceCostPermission: true // Default to true until checked
    };
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    if (this.mappedCustomer && this.mappedCustomer.length > 0) {
      this.switchCustomerId = this.mappedCustomer[0];
    }
    this.getPresetsList();
  },
  methods: {
    redirectToDashboard() {
      this.$router.push({ name: "home" }).catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    getPresetsList() {
      this.PlaygroundService.getPresetsList(this.switchCustomerId).subscribe(
        response => {
          const hasPermission =
            response &&
            response.customer_permission &&
            response.customer_permission.compliance_cost_dashboard !== false;
          // Explicitly set the permission flag
          this.$set(this, "hasComplianceCostPermission", hasPermission);

          if (!hasPermission) {
            // Stop loading indicator
            this.isLoading = false;
          } else {
            this.presetListData = response.result_data;
            this.presetDropDownList = response.result_data.map(item => {
              return {
                id: item.id,
                name: item.preset_scenario_name
              };
            });
            this.isLoading = false;
          }
        },
        e => {
          this.handleApiError(e);
          console.log(e);
          this.isLoading = false;
        }
      );
    },
    createPlayground(formData) {
      formData.preset_scenario = this.item.id;
      formData.top_metric = this.item.selected;
      formData.name = this.item.preset_scenario_name;
      formData.customer_id = this.switchCustomerId;
      this.PlaygroundService.createPlayground(
        formData,
        this.switchCustomerId
      ).subscribe(
        response => {
          this.isCreatePlaygroundModal = false;
          this.newDataAdded.push(true);
          console.log(response, "created");
          this.isLoading = false;
        },
        e => {
          this.handleApiError(e);
          this.isLoading = false;
        }
      );
    },
    openCreatePlaygroundModal(item) {
      this.item = item;
      this.isCreatePlaygroundModal = true;
    },
    closeCreatePlaygroundModal() {
      this.isCreatePlaygroundModal = false;
    },

    handleApiError(reason) {
      let errorMessage = reason.response.data["error"];
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        }
      }
      errorMessage = errorMessage ? errorMessage : "An error occurred";
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
        // onConfirm: () => this.$router.go(),
      });
    }
  }
};
</script>
<style scoped>
.permission-card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 400px; /* Increased height to better display the full background image */
}

.permission-background {
  position: relative;
  z-index: 1;
  min-height: 80vh; /* Make it take up at least 80% of the viewport height */
  display: flex;
  justify-content: center;
  align-items: center;
}

.permission-background::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("~@/assets/image.jpg");
  background-size: contain; /* Shows the full image */
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.8; /* Reduced opacity to make it more subtle */
  z-index: -1;
  border-radius: 12px;
  filter: blur(0px); /* Light blur effect */
  animation: pulse 10s ease-in-out infinite; /* Add subtle animation */
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.4;
  }
}

.permission-card .card {
  max-width: 400px;
  background-color: rgba(
    255,
    255,
    255,
    0.85
  ); /* Make the card semi-transparent */
  backdrop-filter: blur(1px); /* Modern glass effect */
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.2);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  transition: all 0.3s ease;
  transform: translateY(0);
  animation: fadeInUp 0.6s ease-out;
}

.permission-card .card:hover {
  box-shadow: 0 15px 40px rgba(31, 38, 135, 0.3),
    0 0 15px rgba(25, 118, 210, 0.5); /* Add blue glow */
  transform: translateY(-5px);
}

.permission-card .card-content {
  padding: 1.5rem;
}

.permission-image {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0;
}

.permission-icon {
  width: 160px;
  height: auto;
}

.permission-text {
  max-width: fit-content;
}

.permission-content {
  padding-left: 0.5rem;
}

/* .permission-card .title {
  color: #222222;
  font-weight: 700;
  font-size: 2.5rem;
  line-height: 1.3;
  margin-bottom: 1.5rem;
  position: relative;
} */

/*  */

.permission-card .subtitle {
  color: #444444;
  font-weight: normal;
  font-size: 0.95rem;
  line-height: 1.4;
}

.permission-card .contact-text {
  color: #555555;
  font-size: 0.95rem;
}

.permission-card .button {
  min-width: 100px;
  font-weight: 500;
  border-radius: 4px;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

/* Add blur background styling */
.blur-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  opacity: 0.1;
  pointer-events: none;
}

/* Import external dashboard background styles */
@import "../../css/dashboard-bg.css";

.compliance-dashboard {
  position: relative;
}

/* Animation for card appearance */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
